import React, {useEffect, useState, useRef} from 'react';
import LoadingShimmerList from '../../shared/LoadingShimmerList';
import styles from './TableComponent.module.scss';
import config from '../../../config';
import {dummyFunction} from '../../utils/commonUtil';
const TableListComponent = (props) => {
  const {
    list,
    customList,
    EmptyScreenComponent,
    isSearchFilterEmptyState,
    onClickAudienceGrp = dummyFunction,
    onClickCustomGrp = dummyFunction,
    stickyHeader = false,
    UGList = false,
    drawerDetails = {},
    drawerOpen = false,
    headerColor = 'black',
    small = false,
    tableHeaderBold = false,
    componentUGM = false,
    drawerIdForBrokenLink = '',
    isLoading,
    isCustomPresent = false,
  } = props;
  //console.log('>>>> >>>> TableListComponent >>>> props',props);
  const [defaultList, setDefaultList] = useState([]);
  const [defaultLoading, setDefaultLoading] = useState(true);
  const [secondElementList, setSecondElementList] = useState([]);
  const [audienceGroupList, setAudienceGroupList] = useState([]);
  const [userGroupList, setuserGroupList] = useState([]);
  const {currentEnv} = config;
  useEffect(() => {
    setDefaultList(list);
    setAudienceGroupList(list);
    setuserGroupList(customList);
  }, [list, customList]);
  useEffect(() => {
    setDefaultLoading(isLoading);
  }, [isLoading]);
  const getMaxHeight = () => {
    if (userGroupList?.length === 1) return '100px';
    if (userGroupList?.length === 2) return '180px';
    return '260px';
  };

  return (
    <React.Fragment>
      {(audienceGroupList?.length > 0 || userGroupList?.length > 0) && !defaultLoading ? (
        <div
          className={[
            styles.table_container,
            stickyHeader ? styles.sticky_header_user_grp : '',
            headerColor == 'white' ? styles.is_white_header : styles.is_drawer_open,
            UGList ? styles.ug_list_wrapper : '',
          ].join(' ')}
        >
          <div
            className={[
              headerColor == 'white' ? styles.tbl_header_white : styles.tbl_header,
              tableHeaderBold ? styles.head_bold : '',
            ].join(' ')}
          >
            <div className={headerColor == 'white' ? styles.tbl_head_white : styles.tbl_head}>
              User Group Name
            </div>
            <div className={headerColor == 'white' ? styles.tbl_head_white : styles.tbl_head}>
              {/* <div
                className={headerColor == 'white' ? styles.courses_icon_white : styles.courses_icon}
              /> */}
              <div
                className={[
                  headerColor == 'white' ? styles.txt_white : styles.txt,
                  styles.pd_0,
                ].join(' ')}
              >
                Instances
              </div>
            </div>
          </div>
          <div className={styles.tbl_body}>
            {audienceGroupList?.map((ele, index) => {
              return (
                <div className={[styles.tbl_row_wrapper].join(' ')} key={index}>
                  <div
                    id={ele?.audienceGrpName}
                    className={[
                      styles.tbl_row,
                      (ele?.audienceGrpName === drawerDetails?.audienceGrpName ||
                        ele?.audienceGrpName === drawerIdForBrokenLink) &&
                      drawerOpen
                        ? styles.selected
                        : '',
                    ].join(' ')}
                    onClick={(e) => onClickAudienceGrp(e, ele?.audienceGrpName, ele)}
                  >
                    <div className={styles.tbl_data}>
                      <div className={[styles.inner_data, 'ellipsis'].join(' ')}>
                        <div className={[styles.txt, styles.pr_5].join(' ')}>
                          {ele?.audienceGrpName}
                        </div>
                      </div>
                    </div>
                    <div className={[styles.tbl_data, styles.highlight_blue].join(' ')}>
                      <div
                        className={styles.inner_data}
                        //    onClick={() => handleCoursesModal()}
                      >
                        <div className={styles.data_wrapper}>
                          <div className={styles.courses_icon} />
                          <div className={[styles.txt].join(' ')}>{ele?.courseCount}</div>
                        </div>
                        <div className={styles.data_wrapper}>
                          <div className={styles.learning_icon} />
                          <div className={[styles.txt].join(' ')}>{ele?.learningPathCount}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            {userGroupList?.length > 0 ? (
              <>
                <div className={styles.separator}></div>
                {/* Map for Customized User Group */}
                
                  {userGroupList?.map((ele, index) => {
                    return (
                      <div className={[styles.tbl_row_wrapper].join(' ')} key={index}>
                        <div
                          id={ele?.name}
                          className={[
                            styles.tbl_row,
                            (ele?.id === drawerDetails?.audienceGroupId ||
                              ele?.name === drawerIdForBrokenLink) &&
                            drawerOpen
                              ? styles.selected
                              : '',
                          ].join(' ')}
                          onClick={(e) => onClickCustomGrp(e, ele?.id, ele)}
                        >
                          <div className={styles.tbl_data}>
                            <div className={[styles.inner_data, 'ellipsis'].join(' ')}>
                              <div className={[styles.txt, styles.pr_5].join(' ')}>{ele?.name}</div>
                              <div className={styles.spanner}></div>
                            </div>
                          </div>
                          <div className={[styles.tbl_data, styles.highlight_blue].join(' ')}>
                            <div
                              className={styles.inner_data}
                              //    onClick={() => handleCoursesModal()}
                            >
                              <div className={styles.data_wrapper}>
                                <div className={styles.courses_icon} />
                                <div className={[styles.txt].join(' ')}>
                                  {ele?.courseCount || 0}
                                </div>
                              </div>
                              <div className={styles.data_wrapper}>
                                <div className={styles.learning_icon} />
                                <div className={[styles.txt].join(' ')}>
                                  {ele?.learningPathCount || 0}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}

              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      ) : isSearchFilterEmptyState && !defaultLoading ? (
        <EmptyScreenComponent small={small} />
      ) : (
        defaultLoading && (
          <div
            className={[
              styles.table_container,
              stickyHeader ? styles.sticky_header_user_grp : '',
              headerColor == 'white' ? styles.is_white_header : styles.is_drawer_open,
              UGList ? styles.ug_list_wrapper : '',
            ].join(' ')}
          >
            <div
              className={[
                headerColor == 'white' ? styles.tbl_header_white : styles.tbl_header,
                tableHeaderBold ? styles.head_bold : '',
              ].join(' ')}
            >
              <div className={headerColor == 'white' ? styles.tbl_head_white : styles.tbl_head}>
                User Group Name
              </div>
              <div className={headerColor == 'white' ? styles.tbl_head_white : styles.tbl_head}>
                {/* <div
              className={headerColor == 'white' ? styles.courses_icon_white : styles.courses_icon}
            /> */}
                <div
                  className={[
                    headerColor == 'white' ? styles.txt_white : styles.txt,
                    styles.pd_0,
                  ].join(' ')}
                >
                  Instances
                </div>
              </div>
            </div>
            <div className={styles.tbl_body}>
              <LoadingShimmerList count={30} />
            </div>
          </div>
        )
      )}
    </React.Fragment>
  );
};

TableListComponent.propTypes = {};

export default TableListComponent;
